import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "./privateRoute";
import { withTranslation } from "react-i18next";
import { getSessionInfo } from "../Redux/reducer/session";

/* User imports */
import LoginComponent from "../components/shared/user/login/default";
import LoginRedirect from "../components/shared/user/login/redirect";
import Profile from "../components/public/user/profile/profile";
import Landing from "../components/shared/user/landing/";

import Dashboard from "../components/public/dashboard/dashboard";
import PaidRejected from "../components/public/dashboard/paidRejected";
import NotFound from "../components/shared/not-found";

/*Provider imports */
import Provider from "../components/public/provider/provider";
import NewProvider from "../components/public/provider/newProvider";
import ProviderTemplate from "../components/public/provider/template";

//Bills imports
import Bill from "../components/public/bill/bill";
import NewBill from "../components/public/bill/fileBill";
import BillProfile from "../components/public/bill/billProfile";

// Reportes
import ReportsBSC from "../components/private/reports";
import Reports from "../components/public/reports";
import ReportsPRO from "../components/front-provider/reports";
import PublicLogContainer from "../components/public/logs";

// BackOffice imports
import NewBackOfficeProvider from "../components/private/provider/addProviderBSC";
import ClientProfile from "../components/private/provider/profile/";
import AdminApprovals from "../components/private/approvals";
import ClientPage from "../components/private/main/";
import AddClient from "../components/private/main/main";
import ProviderPage from "../components/private/provider/";
import InstitutionMain from "../components/private/provider/institutionProfile";
import TabsProvider from "../components/private/provider/institutionProfile/tabsProvider";
import UserForm from "../components/private/provider/users/providerUsers/userForm";
import Register from "../components/shared/user/register";
import Credentials from "../components/shared/user/credentials";
import AutoEnrolment from "../components/shared/user/register/autoEnrolment";
import Notifications from "../components/private/notifications";
import NotificationDetail from "../components/private/notifications/notificationDetail";

//Admision imports
import Admision from "../components/public/admissions";
import PrivateLogContainer from "../components/private/logs";
import BlankClient from "../components/private/provider/blankClient";
import AdmisionDetail from "../components/public/admissions/contents/admissionDetail";

//FRONT PROVIDER IMPORTS
import ProviderBillsIndex from "../components/front-provider/bills/index";
import DashboardProvider from "../components/front-provider/dashboard/";
import BillDetailPRO from "../components/front-provider/bills/detail";
import ProviderLogContainer from "../components/front-provider/logs";
import ScotiaUsers from "../components/private/provider/users/providerUsers/scotiaUsers";
import Relations from "../components/front-provider/relations";
import RelationDetail from "../components/front-provider/relations/RelationDetail";
import ProviderDetailInfo from "../components/public/provider/template/ProviderDetailInfo";
import RelationTemporal from "../components/front-provider/relations/RelationTemporal";
import RegisterProvider from "../components/public/registerProvider";

// Permissions
import {
  READ,
  WRITE,
  EXECUTE,
  MOD_LOG,
  MOD_BILL,
  MOD_PARAM,
  MOD_PROVID,
  MOD_CUSTOM,
  MOD_DISCONT_PROV,
  MOD_RELATIONS,
} from "../permissions";
import ProviderConfiguration from "../components/public/provider/providerConfiguration";

export const BaseRoutes = (props) => (
  <Switch>
    <Route exact path="/">
      {props.session.authenticated ? (
        props.session.userType === "CSA" ? (
          <Redirect to="/dashboard" />
        ) : props.session.userType === "PRO" ? (
          <Redirect to="/providerSite/dashboard" />
        ) : (
          <Redirect to="/bscadministrator/home" />
        )
      ) : (
        <Redirect to="/landing" />
      )}
    </Route>
    <Route path="/register" exact={true} component={Register} />
    <Route path="/register/new-provider" exact component={RegisterProvider} />
    <Route path="/credentials" exact={true} component={Credentials} />
    <Route path="/clients/login" exact={true}>
      <LoginComponent userType={`CSA`} redirectTo={`suppliers`} />
    </Route>
    <Route path="/providers/login" exact={true}>
      <LoginComponent userType={`PRO`} redirectTo={`clients`} />
    </Route>
    <Route path="/bscadministrator/authenticate" exact={true}>
      <LoginComponent userType={`BSC`} />
    </Route>
    {/* <Route path="/login" exact={true} component={LoginComponent} /> */}
    <Route path="/landing" exact={true} component={Landing} />
    <Route path="/pages/landing" exact={true} component={LoginRedirect} />
    <Route
      path="/register/auto-enrolment"
      exact={true}
      component={AutoEnrolment}
    />
    <Route path="/credentials/reset" exact={true} component={AutoEnrolment} />
    <Route path="/user/reset-password" exact={true} component={AutoEnrolment} />

    <PrivateRoute path="/dashboard" component={Dashboard} />
    <PrivateRoute path="/reports" component={Reports} />
    <PrivateRoute
      path="/logs"
      component={PublicLogContainer}
      module={MOD_LOG}
      allowedActions={[READ]}
    />
    <PrivateRoute path="/providers" exact={true} component={Provider} />
    <PrivateRoute
      path="/providers/configurations"
      exact={true}
      component={ProviderConfiguration}
      module={MOD_PROVID}
      allowedActions={[WRITE, EXECUTE]}
    />
    <PrivateRoute
      path="/providers/add"
      exact={true}
      component={NewProvider}
      module={MOD_PROVID}
      allowedActions={[WRITE]}
    />

    <PrivateRoute
      path="/providers/:providerId/profile"
      exact={true}
      module={[MOD_PROVID, MOD_DISCONT_PROV]}
      allowedActions={[READ, WRITE, EXECUTE]}
      component={ProviderTemplate}
    />
    <PrivateRoute path="/bills" exact={true} component={Bill} />
    <PrivateRoute
      path="/bills/:billId/info"
      exact={true}
      component={BillProfile}
    />
    <PrivateRoute path="/bills/all" exact={true} component={Bill} />
    <PrivateRoute
      path="/bills/rejected"
      exact={true}
      component={PaidRejected}
    />
    <PrivateRoute
      path="/bills/add"
      exact={true}
      component={NewBill}
      module={MOD_BILL}
      allowedActions={[WRITE]}
    />
    <PrivateRoute path="/users" exact={true} component={Profile} />
    <PrivateRoute
      path="/admissions"
      exact={true}
      component={Admision}
      module={[MOD_PROVID, MOD_DISCONT_PROV]}
      allowedActions={[EXECUTE]}
    />

    {/* Admin routes */}
    <PrivateRoute
      path="/bscadministrator/home"
      exact={true}
      component={ClientPage}
    />
    <PrivateRoute
      path="/bscadministrator/reports"
      exact={true}
      component={BlankClient}
    />
    <PrivateRoute
      path="/bscadministrator/audit-reports"
      exact={true}
      component={ReportsBSC}
    />
    <PrivateRoute
      path="/bscadministrator/users/:providerId/:companyId/:id/:countryCode/add"
      exact={true}
      component={ScotiaUsers}
    />
    <PrivateRoute
      path="/bscadministrator/clients/add"
      exact={true}
      component={AddClient}
      module={MOD_CUSTOM}
      allowedActions={[WRITE]}
    />
    <PrivateRoute
      path="/bscadministrator/providers"
      exact={true}
      component={ProviderPage}
    />
    <PrivateRoute
      path="/bscadministrator/providers/add"
      exact={true}
      component={NewBackOfficeProvider}
      module={MOD_PROVID}
      allowedActions={[WRITE]}
    />
    <PrivateRoute
      path="/bscadministrator/add/:clientId/:countryCode"
      exact={true}
      component={ClientProfile}
      module={MOD_CUSTOM}
      allowedActions={[WRITE]}
    />
    <PrivateRoute
      path="/bscadministrator/edit/:id"
      exact={true}
      component={InstitutionMain}
    />
    <PrivateRoute
      path="/bscadministrator/providers/:id/:companyId/profile"
      exact={true}
      component={TabsProvider}
    />
    <PrivateRoute
      // path="/bscadministrator/providers/:providerId/:companyId/:id/:country/add-user"
      path="/bscadministrator/providers/:institutionId/:providerId/:companyId/:id/:country/add-user"
      exact={true}
      component={UserForm}
    />
    <PrivateRoute
      path="/bscadministrator/aprovals"
      exact={true}
      component={AdminApprovals}
    />
    <PrivateRoute
      path="/bscadministrator/logs"
      exact={true}
      component={PrivateLogContainer}
      module={MOD_LOG}
      allowedActions={[READ]}
    />

    <PrivateRoute
      path="/bscadministrator/notifications"
      exact={true}
      module={MOD_PARAM}
      allowedActions={[READ]}
      component={Notifications}
    />

    <PrivateRoute
      path="/bscadministrator/notifications/add"
      exact={true}
      module={MOD_PARAM}
      allowedActions={[WRITE]}
      component={NotificationDetail}
    />

    <PrivateRoute
      path="/bscadministrator/notifications/edit/:id"
      exact={true}
      module={MOD_PARAM}
      allowedActions={[READ]}
      component={NotificationDetail}
    />

    {/* Provider routes */}
    <PrivateRoute
      path="/providerSite/bills"
      exact={true}
      component={ProviderBillsIndex}
    />

    <PrivateRoute
      path="/providerSite/logs"
      exact={true}
      module={MOD_LOG}
      allowedActions={[READ]}
      component={ProviderLogContainer}
    />

    <PrivateRoute
      path="/providerSite/dashboard"
      exact={true}
      component={DashboardProvider}
    />

    <PrivateRoute
      path="/providerSite/relations"
      module={MOD_RELATIONS}
      allowedActions={[READ, WRITE, EXECUTE]}
      exact={true}
      component={Relations}
    />

    <PrivateRoute
      path="/providerSite/relations/detail/:companyId/:currency"
      module={MOD_RELATIONS}
      allowedActions={[READ, WRITE, EXECUTE]}
      exact={true}
      component={RelationDetail}
    />

    <PrivateRoute
      path="/providerSite/relations/provider/detail/:id"
      module={MOD_RELATIONS}
      allowedActions={[READ, WRITE, EXECUTE]}
      exact={true}
      component={RelationTemporal}
    />

    <PrivateRoute
      path="/admissions/detail/:companyId/:requestType"
      module={[MOD_PROVID, MOD_DISCONT_PROV]}
      allowedActions={[READ, WRITE, EXECUTE]}
      exact={true}
      component={AdmisionDetail}
    />

    <PrivateRoute
      path="/admissions/detail/:companyId/:requestType/:currency"
      module={[MOD_PROVID, MOD_DISCONT_PROV]}
      allowedActions={[READ, WRITE, EXECUTE]}
      exact={true}
      component={AdmisionDetail}
    />

    <PrivateRoute
      path="/providers/provider/detail/:companyId/:requestType/:currency"
      module={[MOD_PROVID, MOD_DISCONT_PROV]}
      allowedActions={[READ, WRITE, EXECUTE]}
      exact={true}
      component={ProviderDetailInfo}
    />

    <PrivateRoute
      path="/providerSite/bills/:billId/info"
      exact={true}
      component={BillDetailPRO}
    />
    <PrivateRoute
      path="/providerSite/reports"
      exact={true}
      component={ReportsPRO}
    />

    <Route
      path="/permission/denied"
      exact={true}
      render={(routeProps) => (
        <NotFound
          {...routeProps}
          errorCode={401}
          subtitle={props.t("permission.subTitle")}
          message={props.t("permission.message")}
        />
      )}
    />
    <Route path="*" exact={true} component={NotFound} />
  </Switch>
);

export const mapStateToProps = (state) => {
  return {
    session: getSessionInfo(state),
  };
};

export default connect(mapStateToProps, null)(withTranslation()(BaseRoutes));
